import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-pymes-copagos-carencias',
	standalone: true,
	imports: [CommonModule, TranslateModule],
	templateUrl: './pymes-copagos-carencias.component.html',
	styleUrls: ['./pymes-copagos-carencias.component.scss']
})
export class PymesCopagosCarenciasComponent { }
